import React, { useState, useEffect } from "react";
import images from "../images";
import photocard_images from "./object-lists/photocard-images";
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import { database } from "../firebaseConfig2";

function StatusCurrently(props) {
  console.log("In STATUS CURRENTLY");
    const [status, setStatus] = useState({
       date: 'Loading...',
            craving: 'Loading...',
            learning: 'Loading...',
            playing: 'Loading...',
            reading: 'Loading...',
            watching: 'Loading...'
    });
    const [statusList, setStatusList] = useState([]);
    
    useEffect(
    () =>
      onSnapshot(collection(database, "currently_i_am"), (snapshot) => {
        snapshot.forEach((doc) => {
          let tempdate = new Date(doc.data().date).toString();

          if (tempdate == "Invalid Date"){
            tempdate = doc.data().date;
          }
          let tempstatus = {
            date: tempdate,
            craving: doc.data().craving,
            learning: doc.data().learning,
            playing: doc.data().playing,
            reading: doc.data().reading,
            watching: doc.data().watching
          }
          setStatusList(statusList.push(tempstatus));
        });
        setStatus(statusList.at(-1));
      }),
    []
  );


    return (
//       instead of having a set array like "craving", "learning", etc. --
// push array of string pairs and have statusCurrently.js iterate over it.
// that way i can put whatever i want

    <div className='status-wrapper' id="currently-wrapper">
      <div className="status-title"><p>⊹ currently...</p></div>
        <div className="status-details" id="currently-details">


            {(status.craving != "") && 
                <p> <span className="currently-label">craving:</span>  {status.craving}</p>
            }
           {(status.learning != "") && 
                <p><span className="currently-label">learning:</span> {status.learning}</p>

            }
            {(status.playing != "") && 
                <p><span className="currently-label">playing:</span> {status.playing}</p>
            }
            {(status.reading != "") && 
                <p><span className="currently-label">reading:</span> {status.reading}</p>

            }
            {(status.watching != "") && 
                <p><span className="currently-label">watching:</span> {status.watching}</p>
            }
            </div>
        <img className="deco" id="currently-deco" src={images.bubbles.url}></img>
      </div>
    );
  }

  export default StatusCurrently;